import React, { useState } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import Images from "assets/images/imageData";

const TicketsFilterForm = ({ applyFilter, status = [] }) => {
  const filterInputs = {
    ticketId: "",
    status: "",
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label={localization.ticketId}
        value={filterFieldsData.ticketId}
        regex={Regex.number.test(filterFieldsData.ticketId)}
        type="number"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, ticketId: val })
        }
      />

      <DropDownInput
        disabled={status.length === 0}
        label={localization.status}
        data={status}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, status: val.id })
        }
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src={Images?.ArrowRight} alt="" />
        </button>
      </div>
    </form>
  );
};

export default TicketsFilterForm;
